export const ctaClickTrackingConfig = {
    name: 'CTAClickTracking',
    image: 'https://cdn.zappy.app/d686bf40f1aa0706d104ed34eedb946b.png',
    screenshot: 'https://cdn.zappy.app/c332dc75a048ff4b6cebe273b97d35b5.png',
    inputs: [
        {
            name: 'sectionName',
            type: 'string',
        },
    ],
    canHaveChildren: true,
    category: 'Zapier Utilities',
};
//# sourceMappingURL=config.js.map